<div class="card" style="height:100%; margin-bottom:0;">
  <div class="card-body pt-0">
    <div class="row py-1">
      <div class="col-12">
        @if (this.ValidationErrors.size > 0 && this.editMode) {
        <div class="row mb-3">
          <div class="col-12">
            <div class="alert alert-danger mb-0" role="alert">
              <ul>
                @for (itemMessages of this.ValidationErrors.entries(); track itemMessages) {
                <li>
                  {{itemMessages[0]}}
                  <ul>
                    @for (message of itemMessages[1]; track message) {
                    <li>
                      {{message}}
                    </li>
                    }
                  </ul>
                </li>
                }
              </ul>
            </div>
          </div>
        </div>
        }
        <div class="float-end">
          <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.cancel"
            [disabled]="!editMode || loading"
            (click)="cancelChanges();">Cancel
          </button>
          <button type="button" kendoButton [disabled]="loading" themeColor="primary"
            [svgIcon]="icons.plusCircle" (click)="addNewItem();">Create
          </button>
          <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.save"
            [disabled]="!editMode || loading"
            (click)="saveChanges();">Save
          </button>

          <button type="button" kendoButton #addColumnBtn themeColor="primary" (click)="onToggleAddColumn()" class="k-button"
            [svgIcon]="icons.settings">Add Rate Attribute
          </button>
          <button type="button" kendoButton #removeColumnBtn themeColor="primary" (click)="onToggleRemoveColumn()" class="k-button"
            [svgIcon]="icons.settings">Remove Rate Attribute
          </button>
          @if (showAddColumn) {
          <kendo-popup #addColumnPopup [anchor]="addColumnBtn" class="wrapper">
            <div class="row m-3" style="width: 400px;">
              <div class="col-12">
                <div class="form-group">
                  <label class="font-weight-bold">Available Attributes</label>
                  <kendo-dropdownlist
                    [classList]="'w-100'"
                    [data]="IProjectFieldDtos"
                    [filterable]="true"
                    [kendoDropDownFilter]="filterSettings"
                    [popupSettings]="{ height: 400, width: 400 }"
                    textField="FieldName"
                    valueField="ProjectFieldId"
                    [virtual]="true"
                    [(ngModel)]="addNewIProjectFieldDto">
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                      <span>{{ dataItem.FieldName }}</span> ({{ dataItem.PropertyPathNames }})
                    </ng-template>
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="col-12">
                <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.save"
                  [disabled]="addNewIProjectFieldDto.ProjectFieldId === 0 || loading"
                  (click)="addColumn();">Save
                </button>
              </div>
            </div>
          </kendo-popup>
          }
          @if (showRemoveColumn) {
          <kendo-popup #removeColumnPopup [anchor]="removeColumnBtn" class="wrapper">
            <div class="row m-3" style="width: 400px;">
              <div class="col-12">
                <div class="form-group">
                  <label class="font-weight-bold">Active Attributes</label>
                  <kendo-dropdownlist
                    [classList]="'w-100'"
                    [data]="projectFieldLookups"
                    [filterable]="true"
                    [kendoDropDownFilter]="filterSettings"
                    [popupSettings]="{ height: 400, width: 400 }"
                    textField="FieldName"
                    valueField="ProjectFieldId"
                    [(ngModel)]="removeIProjectFieldDto">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="col-12">
                <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.save"
                  [disabled]="removeIProjectFieldDto.ProjectFieldId === 0 || loading"
                  (click)="removeColumn();">Save
                </button>
              </div>
            </div>
          </kendo-popup>
          }
        </div>
      </div>
    </div>
    <ag-grid-angular #agGridFF class="ag-theme-balham" style="height:calc(100% - 30px);"
      (gridReady)="onGridReady($event)"
      [gridOptions]="gridOptions"
      [suppressDragLeaveHidesColumns]="true"
      [getContextMenuItems]="getContextMenuItems"
      (cellValueChanged)="onCellValueChanged($event)"
      (cellKeyDown)="onCellKeyDown($event)"
      [rowClassRules]="rowClassRules"
      (rangeSelectionChanged)="onRangeSelectionChanged($event)"
      (cellEditingStarted)="onCellEditingStarted($event)"
      (cellEditingStopped)="onCellEditingStopped($event)">
    </ag-grid-angular>
  </div>
</div>

@if (dialogOpened) {
<kendo-dialog
  title="Please confirm"
  (close)="confirmDoNotRemoveProperty()"
  [width]="450">
  <p style="margin: 30px; text-align: center;">
    Removing {{removeIProjectFieldDto.FieldName}} attribute will result in all values for {{removeIProjectFieldDto.FieldName}} attribute to be deleted. Are you sure you want to continue?
  </p>
  <kendo-dialog-actions>
    <button type="button" kendoButton (click)="confirmDoNotRemoveProperty()">No</button>
    <button type="button" kendoButton (click)="confirmRemoveProperty()" themeColor="primary">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
}